import styled from 'styled-components';

import { spacing } from '~/theme';

import { FormTextField } from '~/components/form-elements/text-input/styles';

export const FlexedFormFields = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: ${spacing.spacing7};

    & > div {
        padding-right: ${spacing.spacing5};
    }

    & input {
        margin-bottom: 0;
    }
`;

export const FormDateTextField = styled(FormTextField)`
    width: ${props => (props.maxLength === 2 ? '8ex' : '12ex')};
`;

export default {
    FormDateTextField,
    FlexedFormFields,
};
